<template>
  <div class="ma-4">
    <voice-message-recorder
      @recordingComplete="handleRecordingComplete"
      @cancel="handleCancel"
      @error="handleError"
      :recordInstruction="'ضبط صدای خود را شروع کنید'"
    />

    <div v-if="selectedFile" class="mt-6 text-center">
      <p class="mb-2">فایل ضبط شده: {{ selectedFile.name }}</p>
      <audio controls :src="selectedFileUrl" class="mb-4"></audio>
      <v-btn block class="btn-get-code rounded-lg" @click="emitToParent" :loading="uploading">
        تأیید و انتخاب این صدا
      </v-btn>
    </div>
  </div>
</template>

<script>
import VoiceMessageRecorder from "./VoiceMessageRecorder.vue";

export default {
  name: "createAudio",
  components: { VoiceMessageRecorder },
  data() {
    return {
      selectedFile: null,
      selectedFileUrl: null,
      uploading: false,
    };
  },
  methods: {
    async convertBlobToWav(blob) {
      try {
        const arrayBuffer = await blob.arrayBuffer();
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

        const numOfChan = audioBuffer.numberOfChannels;
        const length = audioBuffer.length * numOfChan * 2 + 44;
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        const channels = [];
        let sample = 0;
        let offset = 0;
        let pos = 0;

        const setUint16 = (data) => { view.setUint16(pos, data, true); pos += 2; };
        const setUint32 = (data) => { view.setUint32(pos, data, true); pos += 4; };

        setUint32(0x46464952); // "RIFF"
        setUint32(length - 8);
        setUint32(0x45564157); // "WAVE"
        setUint32(0x20746d66); // "fmt "
        setUint32(16);
        setUint16(1);
        setUint16(numOfChan);
        setUint32(audioBuffer.sampleRate);
        setUint32(audioBuffer.sampleRate * 2 * numOfChan);
        setUint16(numOfChan * 2);
        setUint16(16);
        setUint32(0x61746164); // "data"
        setUint32(length - pos - 4);

        for (let i = 0; i < audioBuffer.numberOfChannels; i++) {
          channels.push(audioBuffer.getChannelData(i));
        }

        while (pos < length) {
          for (let i = 0; i < numOfChan; i++) {
            sample = Math.max(-1, Math.min(1, channels[i][offset]));
            sample = sample < 0 ? sample * 32768 : sample * 32767;
            view.setInt16(pos, sample, true);
            pos += 2;
          }
          offset++;
        }

        return new Blob([buffer], { type: "audio/wav" });
      } catch (error) {
        console.error("خطا در تبدیل فایل:", error);
        throw error;
      }
    },
    async handleRecordingComplete(blob) {
      if (!blob) return;
      this.$toast?.info("در حال پردازش صدا...");

      try {
        const wavBlob = await this.convertBlobToWav(blob);
        const file = new File([wavBlob], `voice_${Date.now()}.wav`, { type: "audio/wav" });
        
        if (this.selectedFileUrl) URL.revokeObjectURL(this.selectedFileUrl);
        
        this.selectedFile = file;
        this.selectedFileUrl = URL.createObjectURL(file);
      } catch (error) {
        this.$toast?.error("خطا در پردازش صدا");
      }
    },
    handleCancel() {
      this.selectedFile = null;
      if (this.selectedFileUrl) URL.revokeObjectURL(this.selectedFileUrl);
    },
    handleError(msg) {
      this.$toast?.error(msg);
    },
    async emitToParent() {

      this.$emit("onVoiceCreated", this.selectedFile);
    }
  },
  beforeDestroy() {
    if (this.selectedFileUrl) URL.revokeObjectURL(this.selectedFileUrl);
  }
};
</script>
